module.exports = __webpack_public_path__ + "img/d3006e1093494f35867afdcd8df5ad82-1024.2ec396cf.jpg";